module.exports = __webpack_public_path__ + "media/images/pages/trade-anamnese-4de68eb2a25eda143c1dc88c25d3da9b.svg";